import config from "./config";

const SITE_KEY = config.RECAPTCHA_KEY;

let loadPromise = null;

const loadRecaptchaScript = () => {
  if (window.grecaptcha?.execute) {
    return Promise.resolve();
  }
  if (loadPromise) {
    return loadPromise;
  }
  loadPromise = new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = `https://www.google.com/recaptcha/api.js?render=${SITE_KEY}`;
    script.async = true;
    script.onload = () => {
      if (!window.grecaptcha) {
        loadPromise = null;
        reject(new Error("reCAPTCHA failed to load"));
        return;
      }
      window.grecaptcha.ready(resolve);
    };
    script.onerror = () => {
      loadPromise = null;
      reject(new Error("reCAPTCHA failed to load"));
    };
    document.head.appendChild(script);
  });
  return loadPromise;
};

export const executeRecaptcha = async (action = "submit") => {
  await loadRecaptchaScript();
  return window.grecaptcha.execute(SITE_KEY, { action });
};
